import * as React from "react";
import { useState, useEffect, useCallback } from "react";
// @mui material components
import { Box, Grid, Chip, Button, Card, Typography, Tooltip, Alert, List, ListItem, ListItemText, Dialog, FormLabel, DialogTitle, DialogContent, DialogActions, AppBar, Toolbar, IconButton, Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { DatePicker, DesktopTimePicker } from "@mui/x-date-pickers";
import Checkbox from "@mui/material/Checkbox";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import Label from 'components/label/Label';
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/Edit';
import DownloadIcon from '@mui/icons-material/Download';
import { getInternalUsers } from 'api/users';
import AxisCalculator from "./AxisCalculator";


import axios from "axios";
// Others
import CustomInputLabel from "components/custom-input-label";
import customStyle from "customstyle.module.css";
import dayjs from "dayjs";

// Data
import { signatures_live as signatures } from "client-config";
import findingsData from "layouts/manual-Interpretation/data/findingsData";
import suggestedActionsData from "layouts/manual-Interpretation/data/suggestedActionsData";


// import arryhthmiaData from "layouts/manual-Interpretation/data/arryhthmiaData";
// import stemiData from "layouts/manual-Interpretation/data/stemiData";
// import arrhythmiaTextData from "layouts/manual-Interpretation/data/arrhythmiaTextData";
import stemiTextData from "layouts/manual-Interpretation/data/stemiTextData";
import { useSnackbar } from 'components/snackbar'
import LeadTraceMatrixSection from "./LeadTraceMatrixSection";
import DoctorPrescription from "utils/doctorPrescription";
import { getPrescription, LeadTraceMatrix } from "api/reports";
import { useNavigate } from 'react-router-dom';
// import account from "_mock/account";
import { useAuthDispatch } from 'components/AuthStateProvider';




// import Typography from "theme/overrides/Typography";

function CustomReportInputForm({ formKey, displayData, inputData, handleReportInputFormSubmit, businessName, subsDetails, reportData, prescriptionUrl, isLTData, leadReplica }) {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { account } = useAuthDispatch();

  // const [formInput, setFormInputs] = useState(inputData);
  const [formInput, setFormInputs] = useState(() => ({
    ...inputData,
    suggested_actions: normalizeSuggestedActions(inputData?.suggested_actions)
  }));

  const [pdfLoading, setPdfLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [arrhythmiaSuggetions, setArrhythmiaSuggetions] = useState();
  const [leadTraceData, setLeadTraceData] = useState(inputData?.ecg_quality_matrix);
  const [prescriptionButton, setPrescriptionButton] = useState(false)
  const [openPrescription, setOpenPrescription] = useState(false)
  let prescriptionContents = ""
  const [prescriptionContent, setPrescriptionContent] = useState("")
  const [prescriptionLoading, setPrescriptionLoading] = useState(false)

  const [saveAndCloseLoading, setSaveAndCloseLoading] = useState(false);



  const [referredToValue, setReferredToValue] = useState("") // default to empty or an initial value

  const [savingLeadTrace, setSavingLeadTrace] = useState(false);

  const [intervalErrors, setIntervalErrors] = useState({});
  const [suggestedInputText, setSuggestedInputText] = useState("");





  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  let expertPhoneNumber;
  const expertDetails = localStorage.getItem("TokenDetails") && JSON.parse(localStorage.getItem("TokenDetails"))
  if (expertDetails?.userType === "expert") {
    expertPhoneNumber = expertDetails?.phoneNumber;
  }

  // parse subs_details attributes
  if (subsDetails) {
    subsDetails["subscription_type"] = (subsDetails["subscription_type"] || subsDetails["subscriptionType"]) || ""
    subsDetails["plan_name"] = subsDetails["subscription_type"] ? (subsDetails["plan_name"] || subsDetails["planName"]) : ""
    if (!subsDetails["subscription_type"]) subsDetails = null
  }

  // useEffect(() => {
  //   if (!inputData) return;

  //   setFormInputs(prev => ({
  //     ...inputData,
  //     suggested_actions: normalizeSuggestedActions(inputData?.suggested_actions),
  //   }));
  //   document.getElementById("report-input-form");
  //   setPdfLoading(false)
  // }, [inputData]);

  useEffect(() => {
    document.getElementById("report-input-form");
    setPdfLoading(false)
  }, [inputData]);

  useEffect(() => {
    // Check if there are any changes in form values
    const isFormChanged = Object.keys(formInput).some(
      key => formInput[key] !== inputData[key]
    );
    if ((formInput?.report_status === "critical" || formInput?.report_status === "abnormal")) {
      setPrescriptionButton(true);
    } else {
      setPrescriptionButton(false);
    }
    setIsFormChanged(isFormChanged);

  }, [formInput]);

  function readFileAsync(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = function (event) {
        resolve(event.target.result);
      };

      reader.onerror = function (event) {
        reject(event.target.error);
      };

      reader.readAsDataURL(file);
    });
  }
  const handleOpenPrescription = async (e) => {

    setPrescriptionLoading(true)
    if (reportData) {
      const prescription = await getPrescription(reportData?.id)
      if (prescription?.data) {
        setPrescriptionLoading(false)
        setPrescriptionContent(prescription?.data?.html_data)
      }
      setOpenPrescription(true);
      setPrescriptionLoading(false)

    }
  };

  const handleClosePrescription = () => {
    setOpenPrescription(false);
    setPrescriptionContent(prescriptionContents)
  };

  const handleContentChange = (content, pdfData, isSave) => {
    prescriptionContents = content;
    if (isSave) {
      setFormInputs((values) => ({
        ...values,
        "prescription_data": content,
        "prescription_pdf": pdfData
      }));
      handleClosePrescription();
    }
  };




  const handleChange = async (event) => {
    let interval = "";
    const name = event.target.name;
    const value = event.target.value;
    if ((value === "critical" || value === "abnormal")) {
      setPrescriptionButton(true);
    } else {
      setPrescriptionButton(false);
    }
    setFormInputs((values) => ({ ...values, [name]: value }));
    setPdfLoading(false)
    if (name.includes("_box")) {
      // allow empty
      if (value === "") {
        setIntervalErrors(prev => ({ ...prev, [name]: false }));
        setFormInputs(values => ({
          ...values,
          [name]: "",
          [name.replaceAll("_box", "")]: ""
        }));
        return;
      }

      //block non-numeric
      if (!/^\d+(\.\d+)?$/.test(value)) {
        setIntervalErrors(prev => ({ ...prev, [name]: true }));
        return; //STOP calculation here
      }

      //valid numeric value
      setIntervalErrors(prev => ({ ...prev, [name]: false }));

      interval = (parseFloat(value) * 40).toFixed(0);

      setFormInputs(values => ({
        ...values,
        [name]: value,
        [name.replaceAll("_box", "")]: interval
      }));
    }
    if (name === "rr_interval_box") {
      setFormInputs((values) => ({
        ...values,
        ["heart_rate"]: interval !== "" ? (60000 / parseFloat(interval)).toFixed(0) : "",
        ["qtc"]: calculateQTC(formInput["qt_interval"], interval),
      }));
    }
    if (name === "pp_interval_box") {
      setFormInputs((values) => ({
        ...values,
        ["atrial_rate"]: interval !== "" ? (60000 / parseFloat(interval)).toFixed(0) : "",
        ["qtc"]: calculateQTC(formInput["pp_interval"], interval),
      }));
    }
    if (name === "qt_interval_box") {
      setFormInputs((values) => ({
        ...values,
        ["qtc"]: calculateQTC(formInput["qt_interval"], formInput["rr_interval"]),
      }));
    }
    if (name === "total_score") {
      suggetionsFromStemi({ total_score: value });
    }

    if (name === "interpreted_report_file") {
      const file = event.target.files[0];

      try {
        const base64String = await readFileAsync(file);
        setFormInputs((values) => ({
          ...values,
          ["interpreted_report_file"]: base64String,
          ["interpreted_report_file_metadata"]: {
            name: file?.name,
            size: file?.size,
            last_modified_at: file?.lastModified,
            type: file?.type
          },
        }));
      } catch (error) {
        console.error('Error reading file:', error);
      }
    }
  };


  function calculateQTC(qt, rr) {
    if (qt && rr) {
      return parseInt((parseFloat(qt) / 1000 / Math.sqrt(parseFloat(rr) / 1000)) * 1000);
    } else {
      return "";
    }
  }

  // const handleFindingsMultiSelect = (event, selectedOptions, reason) => {
  //   let result = null;
  //   if (reason === "clear") {
  //     suggestedActions(null, true);
  //   } else if (reason === "selectOption" || reason === "removeOption") {
  //     if (selectedOptions.find((option) => option.value === "select-all")) {
  //       result = items.filter((el) => el.value !== "select-all");
  //     } else {
  //       result = selectedOptions;
  //     }
  //     suggestedActions(result);
  //   }
  // };
  const handleFindingsMultiSelect = (event, selectedOptions) => {
    setFormInputs((prev) => ({
      ...prev,
      findings: selectedOptions,
    }));
  };

  function suggestedActions(selectedValues, isRemove) {
    let sugg = formInput["suggested_actions"] || "";
    let resultText = "";
    //Remove All prv selected text
    const newLine = "\n";
    for (var value of findingsData) {
      sugg = sugg.replaceAll(`${value}${newLine}`, "");
    }
    if ((selectedValues || []).length)
      selectedValues.map((item) => {
        if (!sugg.match(item)) resultText += `${item}${newLine}`;
      });
    if (resultText !== "") {
      sugg += resultText;
    }
    setFormInputs((values) => ({
      ...values,
      // ["suggested_actions"]: sugg,
      findings: selectedValues,
    }));
  }

  const handleArrhymiaChange = (event, selectedOptions, reason) => {
    commonAutoCompleteChange(event, selectedOptions, reason, "Arrhymia");
  };

  const handleStemiChange = (event, selectedOptions, reason) => {
    commonAutoCompleteChange(event, selectedOptions, reason, "Stemi");
  };

  function commonAutoCompleteChange(event, selectedOptions, reason, elKey) {
    let result = null;
    if (reason === "clear") {
      if (elKey === "Arrhymia") {
        suggetionsFromArrhymia();
      } else if (elKey === "Stemi") {
        suggetionsFromStemi();
      }
    } else if (reason === "selectOption" || reason === "removeOption") {
      if (selectedOptions.find((option) => option.value === "select-all")) {
        //handleToggleSelectAll();
        // let result = [];
        result = items.filter((el) => el.value !== "select-all");
        // onChange(result);
      } else {
        //handleToggleOption(selectedOptions);
        result = selectedOptions;
        // onChange(selectedOptions);
      }
      const resultKey = {};
      result.map((item) => {
        resultKey[item.title] = true;
      });
      if (elKey === "Arrhymia") {
        suggetionsFromArrhymia(resultKey);
      } else if (elKey === "Stemi") {
        suggetionsFromStemi(resultKey);
      }
    }
  }

  function suggetionsFromArrhymia(resultKey) {
    let resultText = "";
    var sugg = formInput["suggested_actions"] || "";
    if (resultKey) {
      //1. Atrial fibrillation
      if (
        (resultKey["pWaveAbsent"] == true &&
          resultKey["rrVariabilityThresholdgreater25"] == true) ||
        resultKey["interpWaveRategreater250"] == true
      ) {
        resultText += "\n Atrial Fibrillation";
      }
      //2. Atrial Flutter
      if (resultKey["intraprategreater250_350"] == true) {
        resultText += "\n Atrial Flutter";
      }
      //3. Atrial Tachycardia
      // Check for atrial tachycardia based on the combined criteria
      if (
        resultKey["heartRateGreaterThan100"] == true &&
        resultKey["pWaveDurationBetween150And250"] == true &&
        resultKey["narrowQRS"] == true
      ) {
        resultText += "\n Atrial Tachycardia";
      }
      //4. Junctional Rhythm
      // Check for junctional rhythm based on the combined
      //criteria
      if (
        resultKey["pWaveAbsent"] == true &&
        resultKey["heartRateGreaterThan60"] == true &&
        resultKey["rrVariabilityLessThan10(rrVariability)"] == true &&
        resultKey["narrowQRS"] == true
      ) {
        resultText += "\n Junctional Rhythm";
      }
      //5. High Degree AV block
      // Check for high-degree AV block based on the combined criteria
      if (
        resultKey["prolongedPRI"] == true &&
        resultKey["rrVariabilityGreaterThan20(rrVariability)"] == true
      ) {
        resultText += "\n High-Degree AV Block";
      }
      //6. AV block
      // Check for AV block based on the combined criteria
      if (resultKey["prolongedPRI"] == true && resultKey["rrVariabilityLessThan20"] == true) {
        resultText += "\n AV Block";
      }
      //7. WPW syndrome(pre - excitation)
      // Check for Wolff-Parkinson-White (WPW) syndrome based on the combined
      //criteria
      if (resultKey["shortenedPRInterval"] && resultKey["lurredRWave"] && resultKey["wideQRS"]) {
        resultText += "\n Wolff-Parkinson-White (WPW) Syndrome";
      }
      //8. SuperaVenticular Ectopics
      // Check for superaventricular ectopics based on the combined criteria
      if (resultKey["rrVariabilityGreaterThan25"] == true && resultKey["narrowQRS"] == true) {
        resultText += "\n Superaventricular Ectopics";
      }
      //9. Ventricular Ectopics
      // Check for ventricular ectopics based on the combined criteria
      if (resultKey["rrVariabilityGreaterThan25"] == true && resultKey["wideQRS"] == true) {
        resultText += "\n Ventricular Ectopics";
      }
      //10.Superaventricular Tachycardia
      // Check for Supraventricular Tachycardia (SVT) based on the combined
      //criteria
      if (
        resultKey["heartRateGreaterThan100"] &&
        resultKey["absentPWave"] &&
        resultKey["narrowQRS"]
      ) {
        resultText += "\n Supraventricular Tachycardia";
      }
      //11.Ventricular tachycardia
      // Check for Ventricular Tachycardia based on the combined criteria
      if (
        resultKey["heartRateGreaterThan100"] &&
        resultKey["absentPWave"] &&
        resultKey["wideQRS"]
      ) {
        resultText += "\n Ventricular Tachycardia";
      }
      //12.Ventricular premature Complex
      // Check for Ventricular Premature Contraction (VPC) based on the combined
      //criteria
      if (
        resultKey["superimposedPWave"] &&
        resultKey["stDiscordant"] &&
        resultKey["rrVariabilityGreaterThan25"] &&
        resultKey["wideQRS"]
      ) {
        resultText += "\n Ventricular Premature Contraction (VPC) Detected";
      }
      //13.Sinus Bradycardia
      // Check for Sinus Bradycardia based on the criteria
      if (resultKey["heartRateLessThan60"]) {
        resultText += "\n Sinus Bradycardia";
      }
      //14.Sinus Tachycarida
      // Check for Sinus Bradycardia based on the criteria
      if (resultKey["heartRategGreaterThan60"]) {
        resultText += "\n Sinus Tachycardia";
      }
    } else {
      resultText = "";
    }
    //Remove All prv selected text
    for (const value of (arrhythmiaSuggetions || [])) {
      sugg = sugg.replaceAll("\n " + value, "");
    }

    if (resultText !== "") {
      sugg += resultText;
    }
    setFormInputs((values) => ({ ...values, ["suggested_actions"]: sugg }));
  }

  function suggetionsFromStemi(resultKey) {
    let resultText = "";
    var sugg = formInput["suggested_actions"] || "";
    if (resultKey) {
      //1. Left bundle Branch block
      // Check for Left Bundle Branch Block (LBBB) based on the combined criteria
      if (resultKey["wideQRS"] && resultKey["dominantSV1"] && resultKey["notchedMShapeRWaveV5V6"]) {
        resultText += "\n Left Bundle Branch Block (LBBB)";
      }
      //2. Right Branch Bundle Block
      // Check for Right Bundle Branch Block (RBBB) based on the combined criteria
      if (resultKey["rBySRatioGreaterThan1InV1"] && resultKey["wideQRS"]) {
        resultText += "\n Right Bundle Branch Block (RBBB)";
      }
      //3. Anterior Wall MI
      // Check for Anterior Wall Myocardial Infarction (MI) based on the combined criteria
      if (
        resultKey["stElevationOrDepressionInV1"] &&
        resultKey["stElevationOrDepressionInV2"] &&
        resultKey["stElevationOrDepressionInV3"]
      ) {
        resultText += "\n Anterior Wall Myocardial Infarction (MI)";
      }
      //4. Antero - septal MI
      // Check for Antero-septal Myocardial Infarction (MI) based on the combined criteria
      if (
        resultKey["stElevationOrDepressionInV1"] &&
        resultKey["stElevationOrDepressionInV2"] &&
        resultKey["stElevationOrDepressionInV3"] &&
        resultKey["stElevationOrDepressionInV4"] &&
        resultKey["stElevationOrDepressionInV5"]
      ) {
        resultText += "\n Antero-septal Myocardial Infarction (MI)";
      }
      //5. Antero - Apical MI
      // Check for Antero-apical Myocardial Infarction (MI) based on the combined criteria
      if (
        resultKey["stElevationOrDepressionInLeadI"] &&
        resultKey["stElevationOrDepressionInLeadAVL"] &&
        resultKey["stElevationOrDepressionInV2"] &&
        resultKey["stElevationOrDepressionInV3"] &&
        resultKey["stElevationOrDepressionInV4"]
      ) {
        resultText += "\n Antero-apical Myocardial Infarction (MI)";
      }
      //6. Inferior wall MI
      // Check for Inferior Wall Myocardial Infarction (MI) based on the combined criteria
      if (
        resultKey["stElevationOrDepressionInLeadII"] &&
        resultKey["stElevationOrDepressionInLeadIII"] &&
        resultKey["stElevationOrDepressionInLeadAVF"]
      ) {
        resultText += "\n Inferior Wall Myocardial Infarction (MI)";
      }
      //7. Inferolateral MI
      // Check for Infero - lateral Wall Myocardial Infarction(MI) based on the combined criteria
      if (
        resultKey["stElevationOrDepressionInLeadII"] &&
        resultKey["stElevationOrDepressionInLeadIII"] &&
        resultKey["stElevationOrDepressionInLeadAVF"] &&
        resultKey["stElevationOrDepressionInLeadI"] &&
        resultKey["§stElevationOrDepressionInLeadAVL"]
      ) {
        resultText += "\n Infero-lateral Wall Myocardial Infarction (MI)";
      }

      //8. Lateral MI
      // Check for Lateral Wall Myocardial Infarction (MI) based on the combined criteria
      if (
        resultKey["stElevationOrDepressionInLeadI"] &&
        resultKey["stElevationOrDepressionInLeadAVL"] &&
        resultKey["stElevationOrDepressionInV5"] &&
        resultKey["stElevationOrDepressionInV6"]
      ) {
        resultText += "\n Lateral Wall Myocardial Infarction (MI) Detected";
      }
      //9. Ischemia
      // Check for ischemia based on the criteria
      if (resultKey["stSegmentDepression"] || resultKey["tWaveInversion"]) {
        resultText += "\n Ischemia";
      }
      //10.Left Ventricular Hypertrophy
      // Define the threshold for LVH diagnosis
      //int lvhThreshold = 5; //
      //Check for LVH based on the total score
      if (resultKey["total_score"] > 5) {
        resultText += "\n Left Ventricular Hypertrophy(LVH)";
      }
      //11.ST abnormality
      // Check for ST-T abnormality based on the criteria
      if (resultKey["stSegmentElevation"]) {
        resultText += "\n ST-T Abnormality";
      }
    } else {
      resultText = "";
    }
    //Remove All prv selected text
    for (var value of stemiTextData) {
      sugg = sugg.replaceAll("\n " + value, "");
    }
    if (resultText !== "") {
      sugg += resultText;
    }
    setFormInputs((values) => ({ ...values, ["suggested_actions"]: sugg }));
  }

  function onGenerateReportClick(e) {
    e.preventDefault();
    if (isFormChanged) {
      setFormInputs({
        ...formInput,
        date_of_receiving_ecg: formInput?.date_of_receiving_ecg || dayjs(parseInt(formInput?.requested_at)).format("DD/MM/YYYY"),
        time_of_receiving_ecg: formInput?.time_of_receiving_ecg || dayjs(parseInt(formInput?.requested_at)).format("hh:mm A"),
        time_of_ecg_interpretation: formInput?.time_of_ecg_interpretation || dayjs().format("hh:mm A"),
        signature_of: formInput?.signature_of || ((signatures || []).length > 0 ?
          (businessName || (subsDetails?.subscription_type?.toLowerCase() === "trial" || subsDetails?.subscription_type?.toLowerCase() === "paid" || reportData?.payment?.payment_id) ? (signatures.find(item => item["name"] === "Dr. Christianez Ratna") || signatures.find(item => item?.default))
            : signatures.find(item => item["phoneNumber"] === expertPhoneNumber) || signatures.find(item => item?.default))["value"]
          : null)
        ,
        report_status: formInput["report_status"] || "normal"
      });
      setIsDialogOpen(true);
    } else {
      enqueueSnackbar("There is no update to save.", { variant: 'info' })
    }
  }

  const getReferralOptions = (type) => {

    if (type === 'expert') {
      return [
        { value: 'lead-expert', label: 'Refer to Expert 2' },
      ];
    } else if (type === 'lead-expert') {
      return [
        { value: 'doctor', label: 'Refer to Doctor' },
      ];
    }
    return []; // Default empty
  };

  const referralOptions = getReferralOptions(account?.userType);

  async function onConfirmSubmitClick(e, showLoading = true) {
    if (showLoading) setPdfLoading(true);

    const ecg_quality_matrix = {
      ...(leadTraceData || getDefaultLeadMetricesData()),
      ...otherMatrixDataMapping()
    };

    console.log("formInput", formInput)
    await handleReportInputFormSubmit(e, {
      ...formInput,
      suggested_actions: Array.isArray(formInput?.suggested_actions)
        ? formInput.suggested_actions
          .filter(Boolean)
          .map(item => item.trim())
          .join(", ")
        : formInput?.suggested_actions || "",
      referred_to: referredToValue,
      setPdfLoading,
      date_of_receiving_ecg: formInput?.date_of_receiving_ecg || dayjs(parseInt(formInput?.requested_at)).format("DD/MM/YYYY"),
      time_of_receiving_ecg: formInput?.time_of_receiving_ecg || dayjs(parseInt(formInput?.requested_at)).format("hh:mm A"),
      time_of_ecg_interpretation: formInput?.time_of_ecg_interpretation || dayjs().format("hh:mm A"),
      signature_of:
        formInput?.signature_of ||
        ((signatures || []).length > 0
          ? (businessName ||
            (subsDetails?.subscription_type?.toLowerCase() === "trial" ||
              subsDetails?.subscription_type?.toLowerCase() === "paid" || reportData?.payment?.payment_id)
            ? (signatures.find(item => item["name"] === "Dr. Christianez Ratna") ||
              signatures.find(item => item?.default))
            : signatures.find(item => item["phoneNumber"] === expertPhoneNumber) ||
            signatures.find(item => item?.default))["value"]
          : null),
      report_status: formInput["report_status"] || "normal",
      ecg_quality_matrix
    });

    if (showLoading) setPdfLoading(false);
    setIsDialogOpen(false);
  }

  const onCloseDialog = useCallback(() => {
    setIsDialogOpen(false);
  });

  const otherMatrixDataMapping = () => {
    let otherMatrices = {
      r_peaks: [],
      lbbb: false,
      st_elevation: false,
      st_dipression: false,
      mi_all: false
    }
    if (reportData) otherMatrices.r_peaks = reportData?.characteristics?.r_peak_points ?? []
    // if (formInput?.classification_of_abnormality === "LBBB") otherMatrices.lbbb = true
    if (formInput?.classification_of_abnormality === "ST-T Changes") otherMatrices.st_elevation = true
    if (formInput?.classification_of_abnormality === "Myocardial Infraction") otherMatrices.mi_all = true
    if (formInput?.findings?.includes("ST- depression and T-wave inversion")) otherMatrices.st_dipression = true

    return otherMatrices
  }

  const metrices = ['normal', 'noise', 'baseline_wandering', 'loose_electrodes', 'lead_reversal', 'garbage']
  const notNormalMetrices = ["garbage"]
  // Lead trace metrix default data
  const getDefaultLeadMetricesData = () => {
    const leadOrder = [
      'lead1', 'lead2', 'lead3',
      'avr', 'avl', 'avf',
      'v1', 'v2', 'v3', 'v4', 'v5', 'v6'
    ];

    // Sort using the prefix before "_data"
    const leadKeys = (reportData?.leads || []).sort((a, b) => {
      const aKey = a.replace('_data', '');
      const bKey = b.replace('_data', '');
      return leadOrder.indexOf(aKey) - leadOrder.indexOf(bKey);
    });

    let lead_trace_quality = {}

    leadKeys.forEach((lead) => {
      const leadKey = `${lead}`;
      lead_trace_quality[leadKey] = {
        ...metrices.reduce((acc, type, i) => {
          acc[type] = false;   // default: all metrics unchecked
          // default: normal = true
          // acc[type] = i === 0; 
          return acc;
        }, {})
      };
    });

    return { lead_trace_quality, lead_2_q_pathalogical_wave: false };
  }

  const onLeadTraceMatrixUpdate = (updatedData) => {
    setLeadTraceData(updatedData)
  }
  const hasAnySelection = () => {
    if (!leadTraceData) return false;
    if (leadTraceData.lead_2_q_pathalogical_wave) return true;
    const ltq = leadTraceData.lead_trace_quality || {};
    return Object.values(ltq).some((leadRow) =>
      Object.values(leadRow || {}).some(Boolean)
    );
  };

  const handleSaveLTOData = async () => {
    if (!hasAnySelection()) {
      enqueueSnackbar(
        "Please select at least one lead quality option before saving.",
        { variant: "warning" }
      );
      return;
    }
    try {
      setSavingLeadTrace(true);
      const response = await LeadTraceMatrix({
        reportId: reportData?.id,
        ecg_quality_matrix: leadTraceData,
        status: "completed"
      });
      if (response) {
        enqueueSnackbar("Data saved successfully!", { variant: "success" });
        setSavingLeadTrace(false);
      } else {
        enqueueSnackbar("Failed to save data.", { variant: "error" });
        setSavingLeadTrace(false);
      }
    } catch (err) {
      console.error("Error while saving:", err);
      enqueueSnackbar("An error occurred while saving.", { variant: "error" });
      setSavingLeadTrace(false);
    }
  };

  function normalizeSuggestedActions(value) {
    if (!value) return [];

    // already an array → return as is
    if (Array.isArray(value)) return value;

    // string → split by comma
    if (typeof value === "string") {
      return value
        .split(",")
        .map(item => item.trim())
        .filter(Boolean);
    }

    return [];
  }




  return (
    <>
      <form
        id="report-input-form"
        onSubmit={onGenerateReportClick}
      >
        <Grid container spacing={2} style={{ position: "relative" }} margin={0} width="100%">
          {/* <div style={{ padding: '15px', position: 'sticky', top: 0, zIndex: 99999, width: '100%' }}> */}
          {formInput?.completed_at ? (
            <Label color='success' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0 10px' }}>
              <CustomInputLabel>
                Report generated at:{" "}
                <b>{dayjs(parseInt(formInput?.completed_at)).format("DD MMM, YYYY hh:mm A")}</b>
              </CustomInputLabel>
            </Label>
          ) :
            <Label color='info' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0 10px' }}>
              <CustomInputLabel>
                Report taken at:{" "}
                <b>{dayjs(parseInt(displayData?.report_timestamp)).format("DD MMM, YYYY hh:mm A")}</b>
              </CustomInputLabel>
            </Label>
          }
          {/* </div> */}
          <Card className={customStyle.dotedBorder}>
            <Grid container style={{ padding: "15px" }} spacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <DatePicker
                    key={`receive-date-${formKey}`}
                    label="Date of Receiving ECG"
                    name="date_of_receiving_ecg"
                    maxDate={dayjs()}
                    value={
                      formInput?.date_of_receiving_ecg
                        ? dayjs(formInput?.date_of_receiving_ecg, "DD/MM/YYYY")
                        : dayjs(parseInt(formInput?.requested_at))
                    }
                    format="DD/MM/YYYY"
                    closeOnSelect={true}
                    onAccept={(event) =>
                      handleChange({
                        target: {
                          name: "date_of_receiving_ecg",
                          value: dayjs(event).format("DD/MM/YYYY"),
                        },
                      })
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <DesktopTimePicker
                    key={`receive-time-${formKey}`}
                    label="Time of Receiving ECG"
                    openTo="hours"
                    size="small"
                    value={
                      formInput?.time_of_receiving_ecg
                        ? dayjs(formInput?.time_of_receiving_ecg, "hh:mm A")
                        : dayjs(parseInt(formInput?.requested_at))
                    }
                    onAccept={(event) =>
                      handleChange({
                        target: { name: "time_of_receiving_ecg", value: dayjs(event).format("hh:mm A") },
                      })
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <DesktopTimePicker
                    key={`gen-time-${formKey}`}
                    label="Time of ECG Interpretation"
                    openTo="hours"
                    value={
                      formInput?.time_of_ecg_interpretation
                        ? dayjs(formInput?.time_of_ecg_interpretation, "hh:mm A")
                        : dayjs()
                    }
                    onAccept={(event) =>
                      handleChange({
                        target: {
                          name: "time_Of_ecg_interpretation",
                          value: dayjs(event).format("hh:mm A"),
                        },
                      })
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', padding: "5px 0", flexDirection: 'column', justifyContent: 'space-between', backgroundColor: "warning.lighter" }}>
                  {businessName && (<Box width='50%'>
                    <Label
                      color='warning'
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%',
                        padding: '0 10px',
                        m: 1
                      }}>
                      <CustomInputLabel>
                        {businessName && `Business Name: ${businessName}`}
                      </CustomInputLabel>
                    </Label>
                  </Box>)}

                  {(subsDetails ? (<Box>
                    <Chip
                      label={`${subsDetails.subscription_type} - ${subsDetails.plan_name}${reportData?.payment?.payment_id ? `, Paid - ${reportData?.payment?.payment_id}` : ''}`}
                      size="small"
                      color={subsDetails?.subscription_type?.toLowerCase() === "paid" ? 'success' : 'warning'}
                      sx={{ marginLeft: 1, fontSize: '10px', marginTop: 0, textTransform: 'capitalize' }}
                    />
                  </Box>) : (reportData?.payment?.payment_id && (
                    <Box>
                      <Chip
                        label={`Paid: ${reportData?.payment?.payment_id}`}
                        size="small"
                        color="success"
                        sx={{
                          marginLeft: 1,
                          fontSize: '10px',
                          marginTop: 0,
                          textTransform: 'capitalize',
                        }}
                      />
                    </Box>
                  ))
                  )}
                </Box>
              </Grid>

              <Grid item xs={6}>
                <TextField variant="outlined"
                  fullWidth
                  label="First Name"
                  name="first_name"
                  value={formInput?.first_name || ""}
                  onChange={handleChange}
                  size="small" />
              </Grid>
              <Grid item xs={6}>
                <TextField variant="outlined"
                  fullWidth
                  label="Last Name"
                  name="last_name"
                  value={formInput?.last_name || ""}
                  onChange={handleChange}
                  size="small" />
              </Grid>
              <Grid item xs={6}>
                <TextField variant="outlined"
                  fullWidth
                  label="Age"
                  name="age"
                  value={formInput?.age}
                  onChange={handleChange}
                  size="small" />
              </Grid>
              <Grid item xs={6}>
                <TextField fullWidth
                  select
                  name="gender"
                  label="Gender"
                  value={formInput?.gender || "-"}
                  SelectProps={{
                    native: true,
                  }}
                  onChange={handleChange}
                  size="small"
                >
                  <option key="-" value="-" selected disabled>Select</option>
                  <option key="male" value="male" >Male</option>
                  <option key="female" value="female" >Female</option>
                  <option key="other" value="other" >Other</option>
                </TextField>

              </Grid>

            </Grid>
          </Card>

          <Card className={customStyle.dotedBorder}>
            <Grid container style={{ padding: "15px" }} spacing={2}>
              <Grid item xs={6}>
                <TextField fullWidth
                  select
                  name="any_symptom"
                  label="Any Symptoms"
                  value={formInput["any_symptom"] || "Choose Anyone"}
                  SelectProps={{
                    native: true,
                  }}
                  onChange={handleChange}
                  size="small"
                >
                  <option key="Choose Anyone" value="Choose Anyone" selected disabled>Choose Anyone</option>
                  <option key="Chest Pain" value="Chest Pain" >Chest Pain</option>
                  <option key="Shortness of Breath" value="Shortness of Breath" >Shortness of Breath</option>
                  <option key="Any Other" value="Any Other" >Any Other</option>
                  <option key="No Symptoms" value="No Symptoms" >No Symptoms</option>
                  <option key="Tightness">Tightness</option>
                  <option key="Syncope">Syncope</option>
                  <option key="Excessive Perspiration">Excessive Perspiration</option>
                  <option key="Fatigue">Fatigue</option>
                  <option key="Palpitation">Palpitation</option>
                  <option key="Nausea">Nausea</option>
                  <option key="Arm/Shoulder/Jaw Pain">Arm/Shoulder/Jaw Pain</option>

                </TextField>

              </Grid>
              <Grid item xs={6}>
                <TextField fullWidth
                  select
                  name="nature_of_ecg"
                  label="Nature Of ECG"
                  value={formInput["nature_of_ecg"] || "Choose Anyone"}
                  SelectProps={{
                    native: true,
                  }}
                  onChange={handleChange}
                  size="small"
                >
                  <option key="Choose Anyone" value="Choose Anyone" selected disabled>Choose Anyone</option>
                  <option key="Normal ECG" value="Normal ECG" >Normal ECG</option>
                  <option key="Abnormal ECG" value="Abnormal ECG" >Abnormal ECG</option>
                  <option key="Critical ECG" value="Critical ECG" >Critical ECG</option>

                </TextField>
              </Grid>
              <Grid item xs={6}>
                <TextField fullWidth
                  select
                  name="classification_of_abnormality"
                  label="Classification of Abnormality"
                  value={formInput["classification_of_abnormality"] || "Choose Anyone"}
                  SelectProps={{
                    native: true,
                  }}
                  onChange={handleChange}
                  size="small"
                >
                  <option key="Choose Anyone" value="Choose Anyone" selected disabled>Choose Anyone</option>
                  <option key="Arrhythmia" value="Arrhythmia" >Arrhythmia</option>
                  <option key="Ischemia" value="Ischemia" >Ischemia</option>
                  <option key="Myocardial Infraction" value="Myocardial Infraction" >Myocardial Infraction</option>
                  <option key="ST-T Changes" value="ST-T Changes" >ST-T Changes</option>
                  <option key="J Point Elevation" value="J Point Elevation" >J Point Elevation</option>
                  {/* <option key="RBBB" value="RBBB" >RBBB</option> */}
                  {/* <option key="LBBB" value="LBBB" >LBBB</option> */}
                  <option key="BBB" value="Bundle Branch Block (BBB)" >Bundle Branch Block (BBB)</option>
                  <option key="None" value="None" >None</option>
                  <option key="STEMI" value="ST Elevated Myocardial Infarction (STEMI)" >ST Elevated Myocardial Infarction (STEMI)</option>
                  <option key="NSTEMI" value="Non-ST-Elevation Myocardial Infarction (NSTEMI)" >Non-ST-Elevation Myocardial Infarction (NSTEMI)</option>
                </TextField>

              </Grid>
              <Grid item xs={6}>
                <TextField variant="outlined"
                  fullWidth
                  label="Total Score"
                  name="total_score"
                  value={formInput["total_score"]}
                  onChange={handleChange}
                  size="small" />
              </Grid>
            </Grid>
          </Card>
          <Card className={customStyle.dotedBorder}>
            <Grid container style={{ padding: "15px" }} spacing={2}>
              <Grid item xs={12}>

                <Autocomplete
                  multiple
                  id={`choose-findings-${formKey}`}
                  onChange={handleFindingsMultiSelect}
                  name="findings"
                  value={formInput["findings"] || []}
                  options={findingsData}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  renderInput={(params) => {
                    return <TextField {...params} name="ArrhythmiaKey" label="Select Finding(s) from List" placeholder="Choose Multiple" />;
                  }}
                />

              </Grid>
              <Grid item xs={12}>
                {/* <TextField variant="outlined"
                  name="suggested_actions"
                  label="Suggested Actions"
                  value={formInput["suggested_actions"] || ""}
                  onChange={handleChange}
                  placeholder="Type your suggested action"
                  inputProps={{ maxLength: 750 }}
                  multiline
                  fullWidth
                  rows={3}
                  size="small" /> */}


                <Autocomplete
                  multiple
                  freeSolo
                  fullWidth
                  options={suggestedActionsData}
                  // value={normalizeSuggestedActions(formInput?.suggested_actions)}
                  value={formInput?.suggested_actions || []}

                  inputValue={suggestedInputText}
                  onInputChange={(event, newInputValue) => {
                    setSuggestedInputText(newInputValue);
                  }}
                  onChange={(event, value) => {
                    setFormInputs(prev => ({
                      ...prev,
                      suggested_actions: value
                    }));
                  }}
                  onBlur={() => {

                    if (suggestedInputText?.trim()) {
                      setFormInputs(prev => ({
                        ...prev,
                        suggested_actions: [
                          ...normalizeSuggestedActions(prev.suggested_actions),
                          suggestedInputText.trim()
                        ]
                      }));
                      setSuggestedInputText("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Suggested Actions"
                      placeholder="Select or type suggested actions"
                    // multiline
                    />
                  )}
                  sx={{
                    "& .MuiAutocomplete-inputRoot": {
                      alignItems: "flex-start",
                      maxHeight: 120,
                      overflowY: "auto",
                      paddingTop: "6px",
                      paddingBottom: "6px"
                    },
                    "& .MuiAutocomplete-tag": {
                      margin: "4px"
                    }
                  }}

                />

              </Grid>
              {/* Start PR Interval element */}
              <Grid item xs={4}>
                <TextField variant="outlined"
                  label="PR Interval Box"
                  name="pr_interval_box"
                  placeholder="Eg: 4.2"
                  value={formInput["pr_interval_box"] || ""}
                  onChange={handleChange}
                  size="small"
                  error={!!intervalErrors["pr_interval_box"]}
                  helperText={
                    intervalErrors["pr_interval_box"]
                      ? "Only numeric values allowed"
                      : ""
                  }
                  inputProps={{
                    inputMode: "decimal",
                    pattern: "[0-9.]*"
                  }}
                  onWheel={(e) => e.target.blur()}
                />

              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  X 40 =
                </Typography>


              </Grid>
              <Grid item xs={4}>
                <TextField variant="outlined"
                  label="PR Interval"
                  name="pr_interval"
                  inputProps={{ tabIndex: "-1" }}
                  readOnly={true}
                  placeholder="PR Interval"
                  value={formInput["pr_interval"] || ""}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  ms
                </Typography>
              </Grid>
              {/* End Start PR Interval element */}

              {/* Start QRS Interval element */}
              <Grid item xs={4}>
                <TextField
                  label="QRS Interval Box"
                  name="qrs_interval_box"
                  placeholder="Eg: 4.2"
                  value={formInput["qrs_interval_box"] || ""}
                  onChange={handleChange}
                  size="small"
                  error={!!intervalErrors["qrs_interval_box"]}
                  helperText={
                    intervalErrors["qrs_interval_box"]
                      ? "Only numeric values allowed"
                      : ""
                  }
                  inputProps={{
                    inputMode: "decimal",
                    pattern: "[0-9.]*"
                  }}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  X 40 =
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <TextField variant="outlined"
                  label="QRS Interval"
                  name="qrs_interval"
                  inputProps={{ tabIndex: "-1" }}
                  readOnly={true}
                  placeholder="QRS Interval"
                  value={formInput["qrs_interval"] || ""}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  ms
                </Typography>
              </Grid>
              {/* End QRS Interval element */}

              {/* Start QT Interval element */}
              <Grid item xs={4}>
                <TextField
                  label="QT Interval Box"
                  name="qt_interval_box"
                  placeholder="Eg: 4.2"
                  value={formInput["qt_interval_box"] || ""}
                  onChange={handleChange}
                  size="small"
                  error={!!intervalErrors["qt_interval_box"]}
                  helperText={
                    intervalErrors["qt_interval_box"]
                      ? "Only numeric values allowed"
                      : ""
                  }
                  inputProps={{
                    inputMode: "decimal",
                    pattern: "[0-9.]*"
                  }}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  X 40 =
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <TextField variant="outlined"
                  label="QT Interval"
                  name="qt_interval"
                  inputProps={{ tabIndex: "-1" }}
                  readOnly={true}
                  placeholder="QTInterval"
                  value={formInput["qt_interval"] || ""}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  ms
                </Typography>
              </Grid>
              {/* End QT Interval element */}

              {/* Start ST Interval element */}
              <Grid item xs={4}>
                <TextField
                  label="ST Interval Box"
                  name="st_interval_box"
                  placeholder="Eg: 4.2"
                  value={formInput["st_interval_box"] || ""}
                  onChange={handleChange}
                  size="small"
                  error={!!intervalErrors["st_interval_box"]}
                  helperText={
                    intervalErrors["st_interval_box"]
                      ? "Only numeric values allowed"
                      : ""
                  }
                  inputProps={{
                    inputMode: "decimal",
                    pattern: "[0-9.]*"
                  }}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  X 40 =
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <TextField variant="outlined"
                  label="ST Interval"
                  name="st_interval"
                  inputProps={{ tabIndex: "-1" }}
                  readOnly={true}
                  placeholder="ST Interval"
                  value={formInput["st_interval"] || ""}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  ms
                </Typography>
              </Grid>
              {/* End ST Interval element */}

              {/* Start RR Interval element */}
              <Grid item xs={4}>
                <TextField
                  label="RR Interval Box"
                  name="rr_interval_box"
                  value={formInput["rr_interval_box"] || ""}
                  onChange={handleChange}
                  size="small"
                  error={!!intervalErrors["rr_interval_box"]}
                  helperText={
                    intervalErrors["rr_interval_box"]
                      ? "Only numeric values allowed"
                      : ""
                  }
                  inputProps={{
                    inputMode: "decimal",
                    pattern: "[0-9.]*"
                  }}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  X 40 =
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <TextField variant="outlined"
                  label="RR Interval"
                  name="rr_interval"
                  inputProps={{ tabIndex: "-1" }}
                  readOnly={true}
                  placeholder="RR Interval"
                  value={formInput["rr_interval"] || ""}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={2}>
                <Typography mt={1} variant="caption" display="block" gutterBottom>
                  ms
                </Typography>
              </Grid>
            </Grid>
          </Card>
          {/* End RR Interval element */}

          <Card className={customStyle.dotedBorder} sx={{ width: '100%' }}>
            <Grid container style={{ padding: "15px" }} spacing={2}>
              <Grid item xs={6}>
                <Typography mt={1} variant="caption" gutterBottom>
                  Heart Rate = <b>{formInput["heart_rate"] || ""}</b>
                  <br /> <em>[HR = 60000 / RR (ms)]</em>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField display="block" fullWidth
                  select
                  name="heart_rate_axis"
                  label="Heart Rate Axis"
                  value={formInput["heart_rate_axis"] || "Choose Axis"}
                  SelectProps={{
                    native: true,
                  }}
                  onChange={handleChange}
                  size="small"
                >
                  <option key="Choose Axis" value="Choose Axis" selected disabled>Choose Anyone</option>
                  <option key="Normal" value="Normal" >Normal</option>
                  <option key="Left Axis Deviation" value="Left Axis Deviation" >Left Axis Deviation</option>
                  <option key="Right Axis Deviation" value="Right Axis Deviation" >Right Axis Deviation</option>
                  <option key="Extreme Axis" value="Extreme Axis" >Extreme Axis</option>
                  <option key="-" value="-" >NA</option>
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <Typography mt={1} variant="caption" sx={{ width: '100%' }} gutterBottom>
                  QTc = QT / √RR (ms) = <b>{formInput["qtc"] || ""}</b>
                </Typography>
              </Grid>
            </Grid>
            <AxisCalculator
              initialValues={formInput}
              onValuesChange={(vals) => setFormInputs(prev => ({ ...prev, ...vals }))}
            />

          </Card>

          <Card xs={12} className={customStyle.dotedBorder}>
            <LeadTraceMatrixSection
              leadKeys={reportData?.leads || []}
              metrices={metrices}
              notNormalMetrices={notNormalMetrices}
              initialValues={inputData?.ecg_quality_matrix || getDefaultLeadMetricesData()}
              onChange={(updatedData) => onLeadTraceMatrixUpdate(updatedData)}
              ecgReportData={reportData}
              inputFormData={formInput}
              isLTData={isLTData}
              leadReplica={leadReplica}
            />
          </Card>

          <Card xs={12} className={customStyle.dotedBorder}>
            <Grid container style={{ padding: "15px" }} spacing={2}>
              {inputData?.interpreted_report_file_metadata?.name ? <Grid item xs={12} textAlign="center">
                <Alert severity="success" sx={{ whiteSpace: 'break-word', wordBreak: 'break-all' }}>
                  <Tooltip title={inputData?.interpreted_report_file_metadata?.name}>
                    <Typography component="div">
                      Uploaded report:
                      <b> {inputData?.interpreted_report_file_metadata?.name}</b>
                    </Typography>
                  </Tooltip>
                </Alert>
              </Grid> : null}
              {/* <Grid item xs={12}>
                <TextField
                  name="interpreted_report_file"
                  type="file"
                  label="Upload interpreted report (optional)"
                  fullWidth
                  helperText={`Note: ${inputData?.interpreted_report_file_metadata?.name ? "Select to upload the updated report (if any)." : "If already interpreted then upload the report pdf."}`}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ accept: '.pdf' }}
                  onChange={handleChange}
                />
              </Grid> */}
              {/* <Grid item xs={12} sx={{ marginLeft: "15px", borderBottom: '1px dotted #000' }}></Grid> */}
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <CustomInputLabel>Select signature</CustomInputLabel>
                  <Select
                    name="signature_of"
                    value={formInput?.signature_of || ((signatures || []).length > 0 ?
                      (businessName || (subsDetails?.subscription_type?.toLowerCase() === "trial" || subsDetails?.subscription_type?.toLowerCase() === "paid" || reportData?.payment?.payment_id) ? (signatures.find(item => item["name"] === "Dr. Christianez Ratna") || signatures.find(item => item?.default))
                        : signatures.find(item => item["phoneNumber"] === expertPhoneNumber) || signatures.find(item => item?.default))["value"]
                      : null)
                    }
                    onChange={handleChange}
                    fullWidth
                    className={[customStyle.onFocus, "selectInputStyle"]}
                  >
                    {(signatures || []).map((item, index) => (
                      <MenuItem key={`sign-${index}`} value={item.value} selected={item.default}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>

                </FormControl>


              </Grid>
              <Grid item xs={12}>
                <div style={{ display: "flex" }}>
                  <FormControl>
                    <CustomInputLabel>Select report type (for segregation)</CustomInputLabel>
                    <RadioGroup row name="report_status" aria-labelledby="demo-row-radio-buttons-group-label" onChange={handleChange} value={formInput["report_status"] || "normal"}>
                      <FormControlLabel value="normal" control={<Radio />} label="Normal report" />
                      <FormControlLabel value="abnormal" control={<Radio />} label="Abnormal report" />
                      <FormControlLabel value="critical" control={<Radio />} label="Critical report" />
                      <FormControlLabel value="retake" control={<Radio />} label="Retake" />
                    </RadioGroup>
                  </FormControl>
                </div>
              </Grid>
            </Grid>
          </Card>
        </Grid>

        {isLTData ?
          (reportData?.interpretation_data?.ecg_quality_matrix?.status !== "completed" && reportData?.interpretation_request_status === "completed") && (
            <div
              style={{ display: "flex", justifyContent: "center" }}
              className={customStyle.centerBtn}
            >
              <Button
                variant="contained"
                color="info"
                size="medium"
                onClick={handleSaveLTOData}
                disabled={savingLeadTrace}
              >
                {savingLeadTrace ? "Saving..." : "Save Lead Trace Data"}
              </Button>
            </div>
          )
          : <div style={{ display: "flex", justifyContent: "space-evenly" }} className={customStyle.centerBtn}>
            {prescriptionButton && (
              <Button
                variant="outlined"
                color="info"
                size={reportData?.prescriptionUrl ? "small" : "medium"}
                onClick={handleOpenPrescription}
                startIcon={!prescriptionLoading && <EditIcon />} // hide icon when loading
                disabled={prescriptionLoading} // disable while loading
              >
                {prescriptionLoading
                  ? "Loading..."
                  : formInput["prescription_data"]
                    ? "Edit Prescription"
                    : "Prescription"}
              </Button>
            )}

            {reportData?.prescriptionUrl && (
              <Button
                variant="outlined"
                color="info"
                size="small"
                onClick={() => {
                  window.open(reportData.prescriptionUrl, "_blank", "noopener,noreferrer");
                }}
                startIcon={!prescriptionLoading && <DownloadIcon />}
                disabled={prescriptionLoading}
              >
                {prescriptionLoading ? "Opening..." : "Download Prescription"}
              </Button>
            )}
            {/* <Button variant="contained" type="submit" color="info" disabled={pdfLoading ? true : false}>
            {pdfLoading ? 'Loading....' : 'Save & Generate Report'}
          </Button> */}
            <Button variant="contained" type="submit" color="info" disabled={pdfLoading}>
              {pdfLoading ? "Loading…" : "Save & Generate Report"}
            </Button>

          </div>}
        <Dialog open={isDialogOpen} onClose={onCloseDialog} disableScrollLock={false}>
          <DialogTitle>Confirm Save & Generate Report</DialogTitle>
          <DialogContent>
            <Typography>Before generating the report, please review the following details to ensure accuracy:</Typography>
            <List>
              <ListItem key={0}>
                <b>• Signature:</b><ListItemText sx={{ pl: 2 }} primary={`${signatures.find(sign => sign?.value === formInput?.signature_of)?.name || 'Not selected'}`} />
              </ListItem>
              <ListItem key={1}>
                <b>• Report Status: </b><ListItemText sx={{ pl: 2 }} primary={`${formInput?.report_status || 'Not selected'}`} />
              </ListItem>
            </List>
            <Typography variant="body1">
              Please confirm the details above are correct before proceeding.
            </Typography>
            {referralOptions.length > 0 && (
              <FormControl component="fieldset" margin="normal">
                <FormLabel component="legend">Referral Options</FormLabel>
                <RadioGroup
                  aria-label="referred-to"
                  name="referred-to-radio-group"
                  value={referredToValue}
                  onChange={(e) => {
                    setReferredToValue(e.target.value);
                  }}
                  row
                >
                  {referralOptions.map((option) => (
                    <FormControlLabel
                      key={option.value}
                      value={option.value}
                      control={
                        <Radio
                          onClick={(e) => {
                            // If clicking selected radio → unselect it
                            if (referredToValue === option.value) {
                              e.stopPropagation();
                              setReferredToValue("");
                            }
                          }}
                        />
                      }
                      label={option.label}
                    />
                  ))}
                </RadioGroup>

              </FormControl>
            )}

          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 3, gap: 3 }}>
            <Button onClick={onCloseDialog} color="primary" variant="outlined">
              Cancel
            </Button>

            <Button
              color="primary"
              variant="outlined"
              disabled={saveAndCloseLoading}
              onClick={async (e) => {
                try {
                  setSaveAndCloseLoading(true);
                  await onConfirmSubmitClick(e, false); // 👈 no pdfLoading inside
                  onCloseDialog();
                  if (leadReplica) {
                    navigate(`${process.env.REACT_APP_HOMEPAGE}dashboard/all-ecg-reports`);
                  } else {
                    navigate(`${process.env.REACT_APP_HOMEPAGE}dashboard/allReports`);
                  }
                } catch (error) {
                  console.error("Error during save and close:", error);
                } finally {
                  setSaveAndCloseLoading(false);
                }
              }}
            >
              {saveAndCloseLoading ? 'Saving...' : 'Save and Close'}
            </Button>

            <Button
              onClick={(e) => onConfirmSubmitClick(e, true)}
              color="primary"
              variant="contained"
              disabled={pdfLoading ? true : false}
              autoFocus
            >
              {pdfLoading ? 'Saving...' : 'Save'}
            </Button>
          </DialogActions>


        </Dialog>
      </form>
      <Dialog open={openPrescription} fullScreen>
        <AppBar position="relative" color="default" elevation={1}>
          <Toolbar sx={{ justifyContent: 'space-between' }}>
            <Box display="flex" alignItems="center">
              <IconButton edge="start" color="inherit" onClick={handleClosePrescription} aria-label="back">
                <ArrowBackIcon />
              </IconButton>
            </Box>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1, textAlign: 'center', ml: -6 }}>
              Write Prescription
            </Typography>
            <Box sx={{ width: 48 }} /> {/* Spacer to balance center alignment */}
          </Toolbar>
        </AppBar>

        <DialogContent sx={{ padding: 2 }}>
          <DoctorPrescription
            patientData={inputData}
            prescriptionData={prescriptionContent}
            bodyVitals={formInput?.vitals}
            onContentChange={handleContentChange}
            formInput={formInput}
          />
        </DialogContent>


      </Dialog>

    </>
  );
}

export default CustomReportInputForm;


//Backup element for future use so please don't remove below lines
{/* <Grid pt={ 2 } xs={12}>
          <FormControl fullWidth>
            <CustomInputLabel>Arrhythmia</CustomInputLabel>
            <Autocomplete
              multiple
              id={`choose-arrhythmia-${formKey}` }
              className={customStyle.onFocus}
              onChange={handleArrhymiaChange}
              name="ArrhythmiaKey"
              options={arryhthmiaData}
              disableCloseOnSelect
              getOptionLabel={(option) => option.title}
              renderOption={(props, option, { selected }) => (
                <li {...props} data-key='ArrhythmiaKey'>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.title}
                </li>
              )}
              renderInput={(params) => {
                return (<TextField {...params} name='ArrhythmiaKey' placeholder="Choose Multiple" />)
              }}
            />
          </FormControl>
        </Grid> 
        <Grid pt={ 2 } xs={12}>
          <FormControl fullWidth>
            <Autocomplete
              multiple
              id={`choose-stemi-${formKey}` }
              className={customStyle.onFocus}
              onChange={handleStemiChange}
              name="StemiKey"
              data-key='StemiKey'
              options={stemiData}
              disableCloseOnSelect
              getOptionLabel={(option) => option.title}
              renderOption={(props, option, { selected }) => (
                <li {...props} data-key='StemiKey'>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.title}
                </li>
              )}
              renderInput={(params) => {
                return (<TextField {...params} name='StemiKey' data-key='StemiKey' placeholder="Choose Multiple" />)
              }}
            />
          </FormControl>
        </Grid> */}